module.exports = __webpack_public_path__ + "static/media/md-add.9029975f.svg";